import Vue from 'vue'
import locale from 'element-ui/lib/locale'      // elementUI的国际化
import VueI18n from 'vue-i18n'
import messages from './langs'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zh',
  messages
})
locale.i18n((key, value) => i18n.t(key, value)) // elementui多语言切换

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js